import styled, { css } from 'styled-components';

import { media } from '@theme/media';

export const Item = styled.div`
  padding: 0 10px 10px;

  ${media.desktop} {
    padding: 0 30px 80px;
  }
`;

export const defaultImageStyles = css`
  max-width: 100%;
`;
